<template>
    <div class="cart_total">
        <p v-if="totalsParams.oneTimeLabel">
            {{ totalsParams.oneTimeLabel }}
        </p>
        <p
            v-if="totalsParams.oneTimePrice"
            v-html="totalsParams.oneTimePrice"
        ></p>
        <p>{{ totalsParams.label }}</p>
        <p v-html="totalsParams.price"></p>
    </div>
</template>

<script>
export default {
    props: {
        totalsParams: Object,
    }
}
</script>
